import { MutateShopPaymentProvider } from "../models/ShopPaymentProvider";
import { AddressResource } from "../../../model/Address";

export enum CollectionMethod {
  PICKUP = "pickup",
  COURIER = "courier",
  EAT_IN = "eat-in",
}

export enum CaptureOn {
  READY = "ready",
  FINALIZE = "finalize",
  ACCEPT = "accept",
}

export interface Shop {
  id?: string;
  name: string;
  title: string;
  countryCode: string;
  locale?: string;
  venueId?: string;
  loyaltyMode?: "disabled" | "enabled_users_only" | "enabled_all";
  autoAcceptDeliveryAsPreOrder?: boolean;
  autoAcceptPickupAsPreOrder?: boolean;
  deliveryOptions?: string;
  collectionMethodEatInEnabled?: boolean;
  type: "physical" | "digital";
  collectionMethodPickupEnabled?: boolean;
  collectionMethodCourierEnabled?: boolean;
  buzzerStrategy?: string;
  tableStrategy?: string;
  enableCapacityControl?: boolean;
  captureOn: CaptureOn;
  address?: AddressResource;
  postcode?: string;
  shopDeliveryProviderConfigurations?: any[];
  shouldSendTextMessages?: boolean;
  shouldStartManufacturingOnAccept?: boolean;
  menuId?: string;
  autoReadyCollectionMethods?: CollectionMethod[];
  autoDeliverCollectionMethods?: CollectionMethod[];
  allergenesUrl?: string;
  paymentProviders?: MutateShopPaymentProvider[] | null;
}

export interface ShopSuccessResponse {
  data: Shop;
}

export interface UpdateShop {
  organizationKeyName: string;
  id: string;
  data: any;
}

export interface CreateShop {
  organizationKeyName: string;
  data: Shop;
}
